const USER = 'user';
const REPORTING_CYCLE = 'reportingCycle';
export const CREATE_UPDATE_USER = `${USER}/createUpdateUser`;
export const GET_USERS = `${USER}/getUsers`;
export const GET_USERS_DASHBOARD = `${USER}/getUsersForDashboard`;
export const GET_USER = `${USER}/getUser/`;
export const GET_AFFILIATIONS = `${USER}/getUserAffiliations/`;
export const CREATE_AFFILIATION = `${USER}/createUpdateUserAffiliation`;
export const UPDATE_AFFILIATION = `${CREATE_AFFILIATION}/`;
export const GET_TRAININGS = `${USER}/getUserTrainings/`;
export const CREATE_TRAINING = `${USER}/createUpdateUserTraining`;
export const UPDATE_TRAINING = `${CREATE_TRAINING}/`;
export const UPLOAD_BULK_USERS = `${USER}/UploadBulkUsers`;
export const CREATE_FILE_UPLOAD = `${USER}/createUpdateUserFiles`;
export const UPDATE_FILE_UPLOAD = `${CREATE_FILE_UPLOAD}/`;
export const GET_FILE_UPLOAD = `${USER}/getUserFiles/`;
export const GET_USER_FILE_DOWNLOAD = `${USER}/getUserFilesDownload/`;
export const GET_REPORTING_CYCLE = `${REPORTING_CYCLE}/getReportingCycleDetail`;
export const CREATE_REPORTING_CYCLE = `${REPORTING_CYCLE}/CreateUpdateReportingCycle`;
export const GET_COMMENTS = `${REPORTING_CYCLE}/getReportingCycleCommentsDetails/`;
export const GET_USER_ROLES = `${USER}/getUsersRoles`;
